import React, { useState } from "react";
import { User, Role, EventDto } from "./types";

interface Props {
    user: User;
    roles: Role[];
    events: EventDto[];
    onSave: (user: User) => void;
    onCancel: () => void;
}

const UserForm: React.FC<Props> = ({ user, roles, events, onSave, onCancel }) => {
    const [formData, setFormData] = useState<User>({
        ...user,
        roleIds: user.userRoles?.map(r => r.roleId) || [],
        eventIds: user.eventIds || []
    });

    const handleChange = (name: keyof User, value: any) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleRoleToggle = (roleId: number) => {
        const current = formData.roleIds || [];
        handleChange(
            "roleIds",
            current.includes(roleId) ? current.filter(id => id !== roleId) : [...current, roleId]
        );
    };

    const handleEventToggle = (eventId: number) => {
        const current = formData.eventIds || [];
        setFormData({
            ...formData,
            eventIds: current.includes(eventId)
                ? current.filter(id => id !== eventId)
                : [...current, eventId]
        });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="user-form">
            <div className="form-grid">
                <div>
                    <label>Email</label>
                    <input type="email" value={formData.email || ""} onChange={e => handleChange("email", e.target.value)} required />
                </div>
                <div>
                    <label>Telefon</label>
                    <input type="text" value={formData.phone || ""} onChange={e => handleChange("phone", e.target.value)} required />
                </div>

                <div>
                    <label>Fornavn</label>
                    <input type="text" value={formData.firstName || ""} onChange={e => handleChange("firstName", e.target.value)} required />
                </div>
                <div>
                    <label>Efternavn</label>
                    <input type="text" value={formData.lastName || ""} onChange={e => handleChange("lastName", e.target.value)} />
                </div>
            </div>

            <div className="section">
                <div className="section-title">Roller</div>

                <div className="switch-grid">
                    {roles.map(role => {
                        const checked = formData.roleIds?.includes(role.id) || false;

                        return (
                            <label key={role.id} className="switch-row">
                                <span className="switch-label">{role.name}</span>

                                <span className="switch-control">
                                    <input
                                        className="switch-input"
                                        type="checkbox"
                                        checked={checked}
                                        onChange={() => handleRoleToggle(role.id)}
                                    />
                                    <span className="switch-slider" />
                                </span>
                            </label>
                        );
                    })}
                </div>
            </div>

            <div className="section">
                <div className="section-title">Events</div>

                <div className="events-box">
                    {events.map(event => (
                        <label key={event.eventId} className="event-item">
                            <input
                                type="checkbox"
                                checked={formData.eventIds?.includes(event.eventId) || false}
                                onChange={() => handleEventToggle(event.eventId)}
                            />
                            <span>{event.eventName}</span>
                        </label>
                    ))}
                </div>
            </div>
            <div className="form-buttons">
                <button type="submit" className="btn btn--new">Gem</button>
                <button type="button" className="btn btn--function" onClick={onCancel}>Annuller</button>
            </div>
        </form>
    );
};

export default UserForm;